import { createPathFrom } from './../model/commons.model';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SearchCriteria } from '../model/commons.model';
import { CreatePatient, CreatePatientMeasurement,
  Patient, PatientDemoscopicData, PatientFilter, PatientParentData,
  PatientMeasurement, PatientsMeasurementPage, PatientMeasurementFilter,
  PatientSearchPage, UpdatePatient, UpdatePatientDemoscopicData,
  UpdatePatientMeasurement, UpdatePatientParentData
  } from '../model/patient.model';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PatientsService {

  constructor(
    private http: HttpService) { }

    createPatient(dto: CreatePatient): Observable<Patient> {
      return this.http.post(environment.endpoints.patients + `/`, dto) as Observable<Patient>;
    }

    getAllPatients(criteria: SearchCriteria, filter?: PatientFilter): Observable<PatientSearchPage> {
      return this.http.post(environment.endpoints.patients + createPathFrom(criteria), filter) as Observable<PatientSearchPage>;
    }

    getPatient(patientId: string): Observable<Patient> {
      return this.http.get(environment.endpoints.patients + `/${patientId}`) as Observable<Patient>;
    }

    getPatientDemoscopicData(patientId: string): Observable<PatientDemoscopicData> {
      return this.http.get(environment.endpoints.patients + `/patientaccess/${patientId}`) as Observable<PatientDemoscopicData>;
    }

    getPatientParentData(patientId: string): Observable<PatientParentData> {
      return this.http.get(environment.endpoints.patients + `/patientaccess/${patientId}`) as Observable<PatientParentData>;
    }

    updatePatient(patientId: string, body: UpdatePatient): Observable<Patient> {
      return this.http.put(environment.endpoints.patients + `/${patientId}`, body) as Observable<Patient>;
    }

    deletePatient(patientId: string): Observable<any> {
      return this.http.delete(environment.endpoints.patients + `/${patientId}`);
    }

    addPatientMeasurement(patientId: string, body: CreatePatientMeasurement): Observable<any> {
      return this.http.post(environment.endpoints.patients + `/${patientId}/addMeasure`, body);
    }

    updatePatientDemoscopicData(patientId: string, body: UpdatePatientDemoscopicData): Observable<Patient> {
      return this.http.put(environment.endpoints.patients + `/${patientId}/demoscopic`, body) as Observable<Patient>;
    }

    updatePatientParentData(patientId: string, body: UpdatePatientParentData): Observable<Patient> {
      return this.http.put(environment.endpoints.patients + `/${patientId}/parents`, body) as Observable<Patient>;
    }

    updatePatientMeasurement(patientId: string, measurementId: string, body: UpdatePatientMeasurement): Observable<PatientMeasurement> {
      return this.http.put(environment.endpoints.patients +
        `/${patientId}/updateMeasure/${measurementId}`, body) as Observable<PatientMeasurement>;
    }

    getPatientMeasurement(patientId: string, measurementId: string): Observable<PatientMeasurement> {
      return this.http.get(environment.endpoints.patients +
        `/patientaccess/${patientId}/${measurementId}`) as Observable<PatientMeasurement>;
    }

    getAllPatientMeasurements(patientId: string, criteria: SearchCriteria, filter?: PatientMeasurementFilter):
        Observable<PatientsMeasurementPage> {
      return this.http.post(environment.endpoints.patients +
        `/patientaccess/${patientId}` +
        createPathFrom(criteria), filter) as Observable<PatientsMeasurementPage>;
    }
 }
